import {
  dashboardRangeForPreset,
  normalizeDashboardCustomRange,
} from '@/components/dashboard/dashboardDateRange';
import type { DashboardDateRange } from '@/components/dashboard/model';
import { DashboardDateScopeMode, type DashboardDateScope } from './model';

export function resolveDashboardWidgetRange(
  scope: DashboardDateScope,
  globalRange: DashboardDateRange,
  now = new Date(),
) {
  if (scope.mode === DashboardDateScopeMode.Inherit) return globalRange;
  if (scope.mode === DashboardDateScopeMode.Preset) {
    return dashboardRangeForPreset(scope.preset, now);
  }
  return normalizeDashboardCustomRange(scope.dateFrom, scope.dateTo, now) ?? globalRange;
}
